import { SdkError } from "../../services/errors";

const inFlightCancellationFacade = () => {
  let requests = [];

  const cancelInFlightRequestsIfRequested = ({ cancelInFlight }) => {
    if (cancelInFlight) {
      requests
        .filter(request => request.inFlight)
        .forEach(request => request.cancel());
    }
  };

  return {
    cancelTokenExecutor: cancel => {
      const [thisRequest] = requests.filter(request => !request.inFlight);
      cancelInFlightRequestsIfRequested(thisRequest);

      Object.assign(thisRequest, { cancel, inFlight: true });
    },
    makeRequest: async ({ cancelInFlight, request }) => {
      const thisRequest = { cancelInFlight, inFlight: false };

      try {
        requests.push(thisRequest);

        return await request();
      } catch (e) {
        if (e instanceof SdkError) {
          cancelInFlightRequestsIfRequested(thisRequest);
        }
        throw e;
      } finally {
        requests = requests.filter(req => req !== thisRequest);
      }
    }
  };
};

export default inFlightCancellationFacade;
